import type { IncomingHttpHeaders } from 'http'

const REQUEST_HEADERS = {
  BLUE_GREEN: 'blue-green',
}

export const useRequestHeaderStore = defineStore('requestHeaderStore', {
  state: () => ({
    _headers: {} as IncomingHttpHeaders,
  }),
  getters: {
    headers: (state) => {
      return state._headers
    },
    blueGreen: (state) => {
      return state._headers[REQUEST_HEADERS.BLUE_GREEN]
    },
  },
  actions: {
    setRequestHeader(headers: IncomingHttpHeaders) {
      this._headers = headers
    },
  },
})
